import { createRouter, createWebHistory } from 'vue-router'

import { isAuthenticated } from '@/libs/auth'
import { useAppStore } from '@/stores/app'

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition)         return savedPosition
        if (to.hash)               return { el: to.hash }
        if (from.path === to.path) return {}

        return { top: 0, behavior: 'smooth' }
    },
    routes: [
        {
            path:     '/',
            redirect: '/recipes',
        },
        {
            path:      '/login',
            name:      'login',
            component: () => import('@/views/Login.vue'),
            meta:      { layout: 'Blank', requiresAuth: false },
        },
        {
            path:      '/recipes',
            name:      'recipes',
            component: () => import('@/views/recipe/Recipes.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/recipes/new',
            name:      'recipe-new',
            component: () => import('@/views/recipe/RecipeForm.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/recipes/:id',
            name:      'recipe',
            component: () => import('@/views/recipe/Recipe.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/recipes/:id/edit',
            name:      'recipe-edit',
            component: () => import('@/views/recipe/RecipeForm.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/ingredients',
            name:      'ingredients',
            component: () => import('@/views/ingredient/Ingredients.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/tags',
            name:      'tags',
            component: () => import('@/views/tag/Tags.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/meal-plan',
            name:      'meal-plan',
            component: () => import('@/views/meal-plan/MealPlan.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/shopping',
            name:      'shopping',
            component: () => import('@/views/shopping/ShoppingList.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/profile',
            name:      'profile',
            component: () => import('@/views/Profile.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/users',
            name:      'users',
            component: () => import('@/views/user/UserManagement.vue'),
            meta:      { requiresAuth: true },
        },
    ],
})

router.beforeEach((to, _from, next) => {
    const appStore = useAppStore()
    const loggedIn = isAuthenticated()

    if (loggedIn && to.name === 'login') return next({ name: 'recipes' })
    if (to.meta.requiresAuth && !loggedIn) {
        appStore.setLogout()
        return next({ name: 'login' })
    }

    next()
})

export default router
